import type { LanguageResource } from "@ruter-as/web-components-and-tools";

interface ConditionsLanguageResource {
	validationError: string;
	accept: string;
	generalConditionsRuter: string;
	conditionsOfTravelRuter: string;
	generalConditionsAKT: string;
}

const conditionsLanguageResource: LanguageResource<ConditionsLanguageResource> =
	{
		nb: {
			validationError: "Vilkårene må aksepteres.",
			accept: "Jeg aksepterer Ruters vilkår.",
			generalConditionsRuter: "RuterBedrifts vilkår",
			conditionsOfTravelRuter: "Ruters reisevilkår",
			generalConditionsAKT: "AKTs vilkår",
		},
	};

export default conditionsLanguageResource;
